import {setDashboard} from "@/redux/slices/commonSlices/viewTabsSlice";

import {useEffect, useState} from "react";

import {useViewTabs} from "@hooks/ViewTabs";
import {fetchAllDashboardData} from "@redux/slices/dashboardSlices/dashboardCallSlice";
import {SwitchButton} from "@ui/buttons/SwitchButton";
import {BorderArticle} from "@ui/general/BorderArticle";
import {Spinner} from "@ui/general/Spinner";
import moment from "moment";
import {useDispatch, useSelector} from "react-redux";
import {useLocation, useNavigate} from "react-router-dom";

import {Activity} from "./call/Activity";
import {PerformanceCall} from "./call/PerformanceCall";
import {PerformanceCountry} from "./call/PerformanceCountry";
import {UserRanking} from "./call/UserRanking";
import {Confirmations} from "./certification/Confirmations";
import {MarkersScore} from "./certification/MarkersScore";
import styles from "./styles.module.scss";

export const DashboardPage = () => {
  const dispatch = useDispatch();
  const now = moment();
  const startOfToMonth = now.clone().startOf("month");
  const navigate = useNavigate();
  const location = useLocation();
  const {dashboard} = useSelector((state) => state.common.viewTabs);
  const {DASHBOARD_VIEW_TABS} = useViewTabs();

  const {status} = useSelector((state) => state.dashboard.call);
  const [fromDate] = useState(
    startOfToMonth
      .clone()
      .subtract(5, "months")
      .startOf("month")
      .toDate()
      .toISOString(),
  );
  const [toDate] = useState(now.clone().endOf("month").toDate().toISOString());

  useEffect(() => {
    dispatch(fetchAllDashboardData({fromDate, toDate, withArchived: false}));
  }, []);

  const handleClickTab = (item) => {
    navigate(item.link, {replace: true});
    dispatch(setDashboard(item.value));
  };

  const handleTabChange = (value) => {
    const item = DASHBOARD_VIEW_TABS.find((tab) => tab.value === value);
    if (item) handleClickTab(item);
  };

  useEffect(() => {
    const {pathname} = location;

    pathname.includes("/dashboard/certification")
      ? dispatch(setDashboard("certification"))
      : pathname.includes("/dashboard/scenario")
        ? dispatch(setDashboard("call"))
        : undefined;
  }, [location.pathname, dispatch]);

  if (status === "loading") {
    return <Spinner />;
  }

  return (
    <div className={"container-small"}>
      <div className={styles.dashboard}>
        <div className={styles.dashboardSwitch}>
          <SwitchButton
            value={dashboard}
            onChange={handleTabChange}
            switchList={DASHBOARD_VIEW_TABS}
            onClickTab={(item) => handleClickTab(item)}
            width={650}
            height={64}
            fontSize={28}
          />
        </div>

        {dashboard === "call" && (
          <>
            <BorderArticle>
              <PerformanceCall />
            </BorderArticle>

            <BorderArticle>
              <PerformanceCountry />
            </BorderArticle>

            <div className={styles.activityWrapper}>
              <BorderArticle>
                <UserRanking />
              </BorderArticle>

              <BorderArticle>
                <Activity />
              </BorderArticle>
            </div>
          </>
        )}

        {dashboard === "certification" && (
          <>
            <BorderArticle>
              <Confirmations />
            </BorderArticle>

            <BorderArticle>
              <MarkersScore />
            </BorderArticle>
          </>
        )}
      </div>
    </div>
  );
};
